export default __webpack_public_path__ + "static/media/customization.c0c019ab.png";